import { render, staticRenderFns } from "./imprImmDetail.vue?vue&type=template&id=6c7fef0a"
import script from "./imprImmDetail.vue?vue&type=script&lang=js"
export * from "./imprImmDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c7fef0a')) {
      api.createRecord('6c7fef0a', component.options)
    } else {
      api.reload('6c7fef0a', component.options)
    }
    module.hot.accept("./imprImmDetail.vue?vue&type=template&id=6c7fef0a", function () {
      api.rerender('6c7fef0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/ibm/imprImmDetail.vue"
export default component.exports